import React, { SVGProps } from 'react';

export const CanvaDoc = ( props: SVGProps<SVGSVGElement> ) => (
	<svg
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{ ...props }
	>
		<rect width='24' height='24' rx='5' fill='#4C7CF3' />
		<rect x='5.5' y='4' width='13' height='16' rx='1.5' fill='white' />
		<rect x='8' y='7.5' width='8' height='1.5' rx='0.5' fill='#4C7CF3' />
		<rect x='8' y='10.5' width='8' height='1.5' rx='0.5' fill='#4C7CF3' />
		<rect x='8' y='13.5' width='5.5' height='1.5' rx='0.5' fill='#4C7CF3' />
	</svg>
);
